import { YesNoAutocomplete } from "../../../../../../../../../../yes-no-autocomplete/YesNoAutocomplete";

interface Props {
  label: string;
  onConfirm: () => void;
  disabled?: boolean;
}

export function ActionQuestion({ label, onConfirm, disabled }: Props) {
  return (
    <YesNoAutocomplete
      value={null}
      onChange={(value) => {
        if (value === true) {
          onConfirm();
        }
      }}
      label={label}
      disabled={disabled}
      blurOnSelect
    />
  );
}
